//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.AECDesign.js";
import "../Features/Features.AECDesign.BaseLibraryItemBuilder.js";
import "../no/Features.js";
let d=[[],[[[],"CreateMaterialSectionDetailItemBuilder",{R_:{sectionItem:"Features.AECDesign.MaterialSectionDetailItemBuilder"}},0,0],[["name","category"],"SetNameAndCategory",{},2,0],[["identifier"],"Find",{R_:{found:"TaggedObject"}},1,0],[["selectedLibraryItem"],"InitFromBuilder",{},1,0]],[]];
SPLM.Features.AECDesign.MaterialSectionDetailBuilder = class extends SPLM.Features.AECDesign.BaseLibraryItemBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.AECDesign.MaterialSectionDetailBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;